<template>
	<div class="container">

		<!-- Loading加载 -->
		<div class="loading" v-if="isDetail">
			<van-loading size="40px" type="spinner" color="#39CCCD" vertical>
				<div class="loading-text">
					<div>页面正在加载</div>
					<div>请稍候</div>
				</div>
			</van-loading>
		</div>

		<div class="code_top2" v-show="!isDetail">
			<!-- <div style="font-size: 32px;font-weight: 600;margin-top: 30px;">正在加载中</div>  -->
			<div style="font-size: 32px;font-weight: 600;margin-top: 30px;">还差最后一步</div>
			<!-- <div style="font-size: 20px;font-weight: 500;margin-top: 20px;">添加辅导老师，马上激活课程！</div> -->

			<img src="@/assets/userInfo_code02.png" class="ic_success" />
			<div style="font-size: 14px;color: #999;">全程学习跟踪服务，添加老师后方可学习！</div>
		</div>
		
	</div>
</template>

<script>
var that;
import { Toast } from 'vant';
export default {
	name: 'userInfo_code',
	components: {},
	props: {},
	data() {
		return {
			id: '',
			bdVid: '',
			keywordid: '',
			token: '',
			isDetail: true
		}
	},
	created() {
		that = this;
		document.title = '登录';
		that.id = this.$route.query.channel_id;
		that.bdVid = this.$route.query.bd_vid || '';
		that.keywordid = this.$route.query.keywordid || '';
		that.token = this.$route.query.token || '';//d6363d43061043c3862b65b28d530def
		localStorage.setItem('token', that.token);
		setTimeout(() => {
			that.isDetail = false;
			that.addOrder();//进入页面默认下单
		}, 500);
	},
	methods: {
		addOrder() {
			this.$http.post('/app/orders/noSmsAdd', {
				bdVid: that.bdVid,
				channelId: that.id
			}).then(res => {
				setTimeout(() => {
					// this.$router.push({
					// 	path: '/smallprogram/two/success'
					// })

					that.getAgainCourse() 
					
					// if (res.data) {
					// 	this.$router.push({
					// 		path: '/smallprogram/two/success'
					// 	})
					// } else {
					// 	that.getWxInfo()
					// }
				}, 500);
			})
		},

		//已购买训练营，如果训练营过期重新获取绑定最新训练营课程
		getAgainCourse() {
			this.$http.get('/app/users/updateTeacherByChannelId', {
				channelId: this.id
			}).then(res => {
				console.log('重新获取课程', res.data)
				// setTimeout(() => {
				// 	this.$router.push({
				// 		path: '/smallprogram/two/success'
				// 	})
				// }, 500);
				
				this.getWxInfo()
			})
		},

		//支付成功后获取微信昵称头像
		getWxInfo() {
			Toast.loading({
				message: '加载中',
				forbidClick: true,
				loadingType: 'circular'
			});
			console.log('获取vx授权code')
			var url = "https://share.51xxc.com/smallProgram/two/success";
			window.location.replace(`https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxd06acaafd7167053&redirect_uri=${encodeURIComponent(url + '#' + new Date().getTime())}&response_type=code&scope=snsapi_userinfo#wechat_redirect`)
		},

	}
}
</script>

<style scoped lang="less">
.code_top2 {
	text-align: center;
	position: absolute;
    left: 50%;
    top: 42%;
	transform: translate(-50%, -50%);
	width: 100%;

	.ic_success {
		width: 52%;
		margin: 0 auto;
		display: block;
		margin-top: 30px;
		margin-bottom: 20px;
	}
}  

.loading {
	margin: 40vh auto;
	text-align: center;

	.loading-text {
		color: #39CCCD;
		font-weight: bold;
	}
}
</style>